import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 100,
    mobile: {
      desktop: { padding: 100 },
      smartphone: { padding: 30 },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "22pt",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    paddingBottom: 60,
    // color: theme.foregroundColor
  },
  TEXT: {
    // textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "12pt",
    lineHeight: "18pt",
    padding: "20px 0",
    color: theme.foregroundColor,
  },
};
